import { get, post, put, del } from '../../api';

export const getClientesConfiguracoes = () => {
  return get('/api/conectores/configuracoes');
};

export const getConfiguracoes = (idCliente) => {
  return get(`/api/conectores/configuracoes/${idCliente}`);
};

export const getConfiguracao = (idConfiguracao) => {
  return get(`/api/conectores/configuracao/${idConfiguracao}`);
};

export const putConfiguracao = (data) => {
  return put('/api/conectores/configuracao', data);
};

export const postConfiguracao = (data) => {
  return post('/api/conectores/configuracao', data);
};

export const deleteConfiguracao = (id) => {
  return del(`/api/conectores/configuracao/${id}`);
};

export const getConfiguracoesDesbloqueadas = async (idCliente) => {
  try {
    let res = await get(`/api/conectores/configuracoes/${idCliente}/desbloqueadas`);

    res = [{ id: -1, conectorIdentify: 'Não cadastrado' }, ...res];

    return res.map((item) => ({
      key: item.conectorIdentify,
      value: item.conectorIdentify,
      title: item.conectorIdentify,
    }));
  } catch (e) {
    Notification.error(e.message);
  }
};
